import React from "react";
import { MessageCircle } from "lucide-react";
import { siteInfo } from "../data/mock";

const WhatsAppButton = () => {
  const message = encodeURIComponent("Ciao, vorrei informazioni sui vostri corsi");
  const href = `${siteInfo.socials.whatsapp}?text=${message}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contattaci su WhatsApp"
      className="fixed bottom-6 left-6 z-40 group"
    >
      <div className="relative">
        <div className="absolute inset-0 bg-green-500 rounded-full animate-ping opacity-30"></div>
        <div className="relative w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#20BA5A] text-white shadow-2xl flex items-center justify-center transition-all hover:scale-110">
          <MessageCircle className="w-6 h-6" fill="currentColor" strokeWidth={0} />
        </div>
        <div className="absolute left-full ml-3 top-1/2 -translate-y-1/2 bg-white text-brand-dark text-xs font-semibold px-3 py-1.5 rounded-full shadow-md opacity-0 group-hover:opacity-100 pointer-events-none whitespace-nowrap transition-opacity">
          Chatta su WhatsApp
        </div>
      </div>
    </a>
  );
};

export default WhatsAppButton;
